import { z } from 'zod';

export const appleSessionResponseShema = z.object({
  epochTimestamp: z.number(),
  expiresAt: z.number(),
  merchantSessionIdentifier: z.string(),
  nonce: z.string(),
  merchantIdentifier: z.string(),
  domainName: z.string(),
  displayName: z.string(),
  signature: z.string(),
  operationalAnalyticsIdentifier: z.string(),
  retries: z.number(),
  pspId: z.string()
});
